import {
  type GetQConfigGeneratorByIdQuery,
  useGetQConfigGeneratorByIdQuery,
} from '@exam-management/graphql';
import { Loading } from '@shared/components';
import { useMemo, createContext } from 'react';

export interface QConfigGeneratorDetailsContextData {
  qconfigGenerator: GetQConfigGeneratorByIdQuery['excGetQConfigGeneratorById']['qConfigGenerator'];
}

export interface QConfigGeneratorDetailsProviderProps {
  qconfigGeneratorId: string;
  children?: React.ReactNode;
}

export const QConfigGeneratorDetailsContext = createContext<
  QConfigGeneratorDetailsContextData | undefined
>(undefined);

export default function QConfigGeneratorDetailsProvider(
  props: Readonly<QConfigGeneratorDetailsProviderProps>,
) {
  const { children, qconfigGeneratorId } = props;

  const { data, loading } = useGetQConfigGeneratorByIdQuery({
    variables: {
      getQConfigGeneratorByIdInput: {
        id: qconfigGeneratorId,
      },
    },
    // Keep the page when only the QBS labels fail (no QBANK.STRUCTURE.VIEW); the field is then null and the summary shows '-'.
    errorPolicy: 'all',
  });

  const qconfigGeneratorData = useMemo(
    () =>
      data?.excGetQConfigGeneratorById
        .qConfigGenerator as GetQConfigGeneratorByIdQuery['excGetQConfigGeneratorById']['qConfigGenerator'],
    [data],
  );

  const value: QConfigGeneratorDetailsContextData = useMemo(() => {
    return {
      qconfigGenerator: qconfigGeneratorData,
    };
  }, [qconfigGeneratorData]);

  if (loading) {
    return <Loading sx={{ height: '100dvh' }} />;
  }

  return (
    <QConfigGeneratorDetailsContext.Provider value={value}>
      {children}
    </QConfigGeneratorDetailsContext.Provider>
  );
}
